import { z } from 'zod'

export const processOptionalString = z.preprocess(
  val => (val === undefined ? undefined : `${val}`),
  z.string().optional()
)
